<template>
  <div class="video-player">
    <ScriptYouTubePlayer
      ref="video"
      :key="videoId"
      class="video-player__player"
      :trigger="trigger"
      :video-id="videoId"
      :root-attrs="{
        style: {
          borderRadius: `${borderRadius}px`,
          aspectRatio: 1,
          width: '100%',
          maxWidth: `${width}px`,
          height: `${height}px`,
        },
      }"
      :placeholder-attrs="{
        style: {
          objectFit: 'cover',
        },
      }"
    >
      <template #awaitingLoad>
        <slot name="playButton">
          <ButtonYoutubePlay />
        </slot>
      </template>
    </ScriptYouTubePlayer>
  </div>
</template>

<script setup>
import ButtonYoutubePlay from "~/modules/shared/youtubePlayer/ButtonYoutubePlay.vue";

const props = defineProps({
  videoId: { type: String, required: true },
  width: { type: Number, required: false, default: 640 },
  height: { type: Number, required: false, default: 480 },
  borderRadius: { type: Number, required: false, default: 0 },
  trigger: { type: String, required: false, default: "mousedown" },
});

const video = ref(null);
const isPlaying = ref(false);

const playYTVideo = () => {
  !isPlaying.value
    ? video.value?.player.playVideo()
    : video.value?.player.pauseVideo();

  isPlaying.value = !isPlaying.value;
};

const stopYTVideo = () => {
  if (isPlaying.value) {
    video.value?.player.stopVideo();
  }
};

defineExpose({
  playYTVideo,
  stopYTVideo,
  videoId: props.videoId,
});
</script>

<style lang="scss">
.video-player {
  position: relative;

  @include flex-container(row, center, center);

  &__player {
    position: relative;

    img,
    iframe {
      border-radius: calc(v-bind(borderRadius) * 1px);
    }
  }
}
</style>
